<template>
    <tippy
        content-tag="div"
        :allowHTML="true"
        theme="light"
        :arrow="false" 
        :placement="placement"
        :trigger="trigger"
        :onShow="() => $emit('onShow')"
        :onHide="() => $emit('onHide')"
    >
        <template #default>
            <slot name="default"></slot>
        </template>
        <template #content>
            <slot name="content"></slot>
        </template>
    </tippy>
</template>
<script>
import { Tippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'

export default {
    name: "TooltipComponent",
    components: {
        Tippy
    },
    props: {
        trigger: {
            type: String,
            default: 'mouseenter focus'
        },
        placement: {
            type: String,
            default: 'bottom-start'
        }
    }
}
</script>